
import BaseCard from '@/components/base/BaseCard.vue';
import { Component, Prop, Vue, PropSync } from 'vue-property-decorator';
import { IEmployeeAffiliateMethod } from '@/api/types/payout';
import { formatPhone, translatePaymentsRequisite } from '@/utils/translate';
import { sortPayoutMethodFields } from '@/utils/payoutMethodFields';
import { searchWebmasters } from '@/api/org-cabinets-backend';
import Status from '@/components/base/Status.vue';
import BaseAutocomplete from '@/components/base/design/BaseAutocomplete.vue';
import BaseList from '@/components-UI/list/BaseList.vue';
import BaseListItem from '@/components-UI/list/BaseListItem.vue';

@Component({
    components: {
        BaseCard,
        Status,
        BaseAutocomplete,
        BaseList,
        BaseListItem,
    },
})

export default class PayoutMethodRequisites extends Vue {
    @Prop({ required: true }) employeeAffiliateMethod!: IEmployeeAffiliateMethod;
    @Prop({}) isShowEditFields!: boolean;
    @Prop({}) methodData!: IEmployeeAffiliateMethod;
    @PropSync('defaultSearch', { required: false }) search!: string;
    @PropSync('managerFieldsKeys', { required: false }) keys!: {};

    translatePaymentsRequisite = translatePaymentsRequisite;
    formatPhone = formatPhone;
    searchWebmasters = searchWebmasters;

    /**
     * `methodData` - это только слитые partner_data и manager_data, id способа
     * в них нет. Берём его из самой заявки, иначе подписи полей теряют
     * привязку к способу (например «Имя» вместо «ФИО» у bank_card_ru_v1).
     */
    get methodId(): string | undefined {
        return this.employeeAffiliateMethod?.method_id;
    }

    get requisiteNames(): string[] {
        return sortPayoutMethodFields(Object.keys(this.methodData ?? {}), this.methodId);
    }

    get editableFieldNames(): string[] {
        return sortPayoutMethodFields(Object.keys(this.keys ?? {}), this.methodId);
    }

    get isDisabledField(): boolean {
        return this.employeeAffiliateMethod.status === 'partner_rejected' ||
            this.employeeAffiliateMethod.status === 'deleted';
    }

    get isShowFields(): (name: string) => boolean {
        return (name: string): boolean => {
            return this.isShowEditFields &&
                !(this.employeeAffiliateMethod.method?.name.ru.includes('Договор (Россия и Казахстан)') &&
                    name === 'legal_name');
        };
    }

    changeFieldValue(key: string, value: string): void {
        this.keys[key] = value;
        this.$emit('change', this.keys);
    }
}
